export default __webpack_public_path__ + "static/media/group-3-copy-2.6cc628a4.png";